var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQiaoguanmu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4018_3892)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4018_3892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5L10 11.5L9.5 12.5L7 13H5.5L2.5 12L2 10.5L1 9L2.5 6L3.5 4L5 2H8L9 3.5L10 5.5L11 6L12 8V9.5Z",
    fill: "#44C530",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9L7 11.5V16",
    stroke: "#7B4A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5L8 8",
    stroke: "#7B4A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15L10 16H14L14.5 15.5L15 14.5L14 13H13.5L12.5 11.5H11L9.5 13L9 14L9.5 15Z",
    fill: "#78CE71",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4018_3892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4018_3892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiaoguanmu);
export default __webpack_public_path__ + "static/media/qiaoguanmu.09310a7e09e8cfaab838c5e3cddfde68.svg";
export { ForwardRef as ReactComponent };